













































































































































import { Component, Emit, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import {
  BookMaxlength,
  MarkMaxlength,
  NdcMask,
  NdcMaxlength,
  SubMaxlength
} from '@/types'

export interface InputEditWhereAboutItem {
  holdingBranchCode: {
    input: string
    errorMessage: string
  }
  forwardingBranchCode: {
    input: string
    errorMessage: string
  }
  departmentCode: {
    input: string
    errorMessage: string
  }
  shelfType: {
    input: string
    errorMessage: string
  }
  shelfTypeOld: {
    input: string
    errorMessage: string
  }
  mark: {
    input: string
    errorMessage: string
  }
  ndc: {
    input: string
    errorMessage: string
  }
  book: {
    input: string
    errorMessage: string
  }
  sub: {
    input: string
    errorMessage: string
  }
}

export const defaultInputEditWhereAboutItem = (): InputEditWhereAboutItem => ({
  holdingBranchCode: {
    input: '',
    errorMessage: ''
  },
  forwardingBranchCode: {
    input: '',
    errorMessage: ''
  },
  departmentCode: {
    input: '',
    errorMessage: ''
  },
  shelfType: {
    input: '',
    errorMessage: ''
  },
  shelfTypeOld: {
    input: '',
    errorMessage: ''
  },
  mark: {
    input: '',
    errorMessage: ''
  },
  ndc: {
    input: '',
    errorMessage: ''
  },
  book: {
    input: '',
    errorMessage: ''
  },
  sub: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCode
  }
})
export default class CollectionEditCollectionWhereAboutInfo extends ComponentVue {
  @Prop({
    type: Boolean,
    default: false
  })
  disabledForwardingBranchCode!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabledShelfType!: boolean

  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InputEditWhereAboutItem

  get markMaxlength(): string {
    return MarkMaxlength
  }

  get ndcMask(): string {
    return NdcMask
  }

  get ndcMaxlength(): string {
    return NdcMaxlength
  }

  get bookMaxlength(): string {
    return BookMaxlength
  }

  get subMaxlength(): string {
    return SubMaxlength
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  @Emit('convert:shelf-type')
  onConvertShelfType(): void {}
}
